import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { UserLayout } from 'components/layout/UserLayout'
import { FullPageHeader } from 'components/layout/FullPageLayout/Header/FullPageHeader'
import { useSprintPacket } from 'hooks/api/useSprintPackets'
import { PacketEditorBody } from './editor/PacketEditorBody'
import { usePacketFonts } from './usePacketFonts'

export function EditSprintPacket() {
  usePacketFonts()
  const { businessID, packetID } = useParams<{ businessID: string; packetID: string }>()
  const packetIDNum = Number(packetID)
  const { packet } = useSprintPacket(packetIDNum)

  // Carried-forward slides nobody has looked at yet. Deliberately shown here,
  // beside the Present button, and never inside Present itself — the client may
  // be in the room. It never blocks presenting.
  const unreviewedCount = (packet?.customSections ?? []).filter(s => s.needsReview).length

  const sprintCrumb = packet?.sprint?.name ?? 'Sprint'
  const breadcrumbs = [
    { title: 'Sprint Packets', route: `/${businessID}/sprint-packets` },
    { title: sprintCrumb },
    { title: 'Edit' },
  ]

  return (
    <UserLayout>
      <FullPageHeader breadcrumbs={breadcrumbs}>
        <div className="ml-auto pr-4 flex items-center gap-3">
          {unreviewedCount > 0 && (
            <span className="text-xs font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1.5">
              {unreviewedCount} slide{unreviewedCount === 1 ? '' : 's'} not reviewed
            </span>
          )}
          <Link
            to={`/${businessID}/sprint-packets/${packetID}/review`}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-purple-600 text-purple-600 hover:bg-purple-50 text-sm font-semibold transition-colors"
          >
            <i className="fa fa-check" />
            Review
          </Link>
          <Link
            to={`/${businessID}/sprint-packets/${packetID}/present`}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold transition-colors"
          >
            <i className="fa fa-play" />
            Present
          </Link>
        </div>
      </FullPageHeader>
      <PacketEditorBody businessID={Number(businessID)} packetID={packetIDNum} />
    </UserLayout>
  )
}
